import React from 'react';
import { Button, Checkbox, FormControl, Modal } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { connect } from 'react-redux';

import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';

import { Link } from "react-router-dom";
import TooltipElement from '../components/tooltipElement';
import TooltipButtonGroup from '../components/tooltipButtonGroup';
import OverlayLoader from '../components/overlayLoader';
import { ColumnFormatters } from '../components/tableColumnFilterFormatters';
import * as historyActions from '../store/historySlice';
import { historySelectors } from '../store/historySlice';
import setTitleToFilters from '../common/filtersTitles';
import * as settingsActions from '../store/settingsSlice';
import { settingsSelectors } from '../store/settingsSlice';

import './common.css';
import * as filterValuesActions from '../store/userConfigs/filterValuesSlice';
import FilterTableHeader from '../components/filterTableHeader';
import extractSearchParams from '../common/extractSearchParams';
import * as sortTablesActions from '../store/userConfigs/orderTablesSlice';
import WrongActivationsHistoryTable from '../components/wrongActivationsHistoryTable';
import { userConfigsSelectors } from '../store/userConfigs';

import { downloadTrialAndPermanentActivations } from '../services/history'
import * as download from 'downloadjs';

const ItemsPerPageModes = [10, 25, 30, 50, 100];

const thatObjectName = 'history';

class HistoryContainer extends React.Component {
  constructor(props) {
    super(props);

    this.columns = [{
      dataField: 'device.key',
      text: 'Device key',
      sort: true,
      filter_: { type: 'text' },
      defaultDisplayed: true,
      headerStyle: () => ({ maxWidth: '12em' })
    }, {
      dataField: 'deviceKeyList',
      text: 'Request device keys',
      sort: true,
      filter_: { type: 'text' },
      defaultDisplayed: true
    }, {
      dataField: 'unstableDeviceKeyList',
      text: 'Unstable request device keys',
      sort: true,
      filter_: { type: 'text' }
    }, {
      dataField: 'productName',
      text: 'Product name',
      sort: true,
      filter_: { type: 'text' },
      defaultDisplayed: true,
      headerStyle: () => ({ maxWidth: '7em' })
    }, {
      dataField: 'productVersion',
      text: 'Product version',
      sort: true,
      filter_: { type: 'text' },
      defaultDisplayed: true,
      headerStyle: () => ({ maxWidth: '8em' })
    }, {
      dataField: 'connectionDateTime',
      text: 'Event time',
      sort: true,
      filter_: { type: 'datetime' },
      defaultDisplayed: true,
      headerStyle: () => ({
        minWidth: '8em',
        maxWidth: '11em'
      })
    }, {
      dataField: 'ip',
      text: 'IP address',
      sort: true,
      filter_: {
        type: 'text',
        searchable: true,
      },
      defaultDisplayed: true,
      headerStyle: () => ({ maxWidth: '10em' })
    }, {
      dataField: 'requestType',
      text: 'Request type',
      sort: true,
      filter_: { type: 'text' },
      defaultDisplayed: true,
      headerStyle: () => ({ maxWidth: '5em' })
    }, {
      dataField: 'responseType',
      text: 'Response type',
      sort: true,
      filter_: { type: 'text' },
      defaultDisplayed: true,
      headerStyle: () => ({ maxWidth: '7em' })
    }, {
      dataField: 'protocolNumber',
      text: 'Protocol',
      sort: true,
      filter_: { type: 'text' }
    }, {
      dataField: 'inputLicenseKey',
      text: 'Request license key',
      sort: true,
      filter_: { type: 'text' },
      defaultDisplayed: true,
      headerStyle: () => ({ maxWidth: '15em' }),
      formatter: (cell, row, rowIndex) => {
        return (<Link to={this.getLinkToTab(cell, row, rowIndex)}>{cell}</Link>)
      }
    }, {
      dataField: 'trialFeatures',
      text: 'Trial features',
      sort: true,
      filter_: { type: 'text' }
    }, {
      dataField: 'outputLicenseKey',
      text: 'Response license key',
      sort: true,
      filter_: { type: 'text' },
      defaultDisplayed: true,
      headerStyle: () => ({ maxWidth: '15em' }),
      formatter: (cell, row, rowIndex) => {
        return (<Link to={this.getLinkToTab(cell, row, rowIndex)}>{cell}</Link>)
      }
    }, {
      dataField: 'connectionUid',
      text: 'Connection Uid',
      sort: true,
      filter_: { type: 'text' }
    }, {
      dataField: 'features',
      text: 'Response features',
      sort: true,
      filter_: { type: 'text' }
    }, {
      dataField: 'expirationDateTime',
      text: 'Expiration time',
      sort: true,
      filter_: { type: 'text' },
      headerStyle: () => ({
        minWidth: '8em',
        maxWidth: '11em'
      })
    }, {
      dataField: 'ai_account',
      text: 'AI account',
      sort: true,
      filter_: { type: 'text' },
      formatter: (cell) => {
        if (!cell) return '';
        const provider = cell.match(/\[(.*),/) ? cell.match(/\[(.*),/)[1] : cell.match(/\[(.*)]/)[1];
        const login = cell.match(/^(.*) \[/)[1];
        return <Link to={`/ai-accounts?login=${login}&provider=${provider}`}>{cell}</Link>;
      }
    }, {
      dataField: 'error',
      text: 'Error',
      sort: true,
      filter_: { type: 'text' }
    }, {
      dataField: 'isForceTrial',
      text: 'Force trial',
      sort: true,
      filter_: {
        type: 'select',
        values: {
          all: '',
          true: 'true',
          false: 'false'
        }
      }
    }].map(column => ({
      ...column,
      headerFormatter: this.createColumnFormatter(column.dataField, column.filter_.type, column.filter_.values),
      headerAttrs: { 'data-tooltip-type': column.filter_.type },
      onSort: (field, order) => {
        this.props.setOrderDirection(field, order);
      },
      events: {
        onClick: (e, column, columnIndex, row) => {
          if (column.filter_.searchable && e.altKey) {
            let colName = column.dataField;
            // Разбиение вложенного объекта для корректного обращения
            let resolvedPath = colName.split('.').reduce((prev, curr) => prev && prev[curr], row);
            this.props.setFilterValue(colName, resolvedPath).then(this.reloadHistory);
          }
        },
      }
    }));

    this.state = {
      pagination: {
        sizePerPage: ItemsPerPageModes[0],
        page: 1
      },
      data: [],
      displayedColumns: this.columns.filter(
        column => column.defaultDisplayed !== undefined && column.defaultDisplayed).map(column => column.dataField),
      isShowWrongActivationsTable: false,
      selectedYear: new Date().getFullYear()
    };

    this.props.setPagination(this.state.pagination);
  }

  reloadHistory = () => {
    const { pagination } = this.state;
    const { sort, filters, isBackgroundRequestsEnabled } = this.props;
    this.setState({
      pagination: {
        ...this.state.pagination,
        page: 1
      }
    }, () => {
      if (isBackgroundRequestsEnabled) {
        this.props.fetchHistoryTotal({ filters });
      }
      this.props.fetchStartHistory({ filters, sort, limit: pagination.sizePerPage });
    });
  };

  handleToggleIsBackgroundRequestsEnabled = (isBackgroundRequestsEnabled) => {
    const { filters } = this.props;

    if (isBackgroundRequestsEnabled) {
      this.props.fetchHistoryTotal({ filters });
    }
  }

  componentDidMount() {
    setTitleToFilters();
    const deviceFilterValue = extractSearchParams(this.props.requestData.location.search, 'device.key');
    if (deviceFilterValue) {
      this.props.setFilterValue('device.key', deviceFilterValue).then(this.reloadHistory);
    } else {
      this.reloadHistory();
    }

    this.props.fetchUserSettings().then(() => {
      this.setState({
        displayedColumns: this.columns.filter(
          column => {
            const { visibleColumns } = this.props.settings;
            if (visibleColumns === undefined || visibleColumns === null)
              return column.defaultDisplayed !== undefined && column.defaultDisplayed;
            return visibleColumns.includes(column.dataField);
          }).map(column => column.dataField)
      });
    });
  }

  render() {
    return (
      <OverlayLoader active={this.isLoading()} text={this.getLoaderMessage()}>
        <div>
          <h1>History</h1>
          {this.renderButtons()}
          {this.renderContent()}
          {this.renderWrongActivationsTable()}
        </div>
      </OverlayLoader>
    );
  }

  downloadActivations = () => {
    downloadTrialAndPermanentActivations(this.state.selectedYear)
    .then((res) => {
      // console.log(res);
      download(res.data, `Trial And Permanent Activations - ${this.state.selectedYear}`)
    })
    .catch((err) => {
      console.log(err);
    });
  }

  renderDownloadSelect = () => {
    const yearCountFrom = 2016,
      yearNow = new Date().getFullYear(), 
      years = Array.from({ length: yearNow - yearCountFrom + 1 }, (_, v) => {
        return yearNow - v;
      });

    return <div className="d-flex ml-2 join-elements">
     <TooltipButtonGroup>
        <FormControl className='d-inline-block' componentClass="select" onClick={e => e.stopPropagation()} onChange={(e) => {
          this.setState({ selectedYear: Number(e.target.value) });
        }}>
          {
            years.map((year) => {
              return <option key={year} value={year}>{year}</option>
            })
          }
        </FormControl>
        <TooltipElement type="button" text={`Download activations for year ${this.state.selectedYear}`} icon="download" onClick={this.downloadActivations} />
      </TooltipButtonGroup>
    </div>
  }

  renderButtons = () => {
    return <div className="d-flex">
      <TooltipButtonGroup>
        <TooltipElement type="button" text="Filter / Refresh" icon="filter" onClick={this.reloadHistory} />
        <TooltipElement type="button" text="Show wrong activations" icon="eye-open" onClick={this.showWrongActivationsTable} />
      </TooltipButtonGroup>

      {this.renderDownloadSelect()}
    </div>
  };

  renderContent = () => [this.renderError(), this.renderTable()];

  renderError = () => {
    let error = null;
    if (this.props.historyState.error) error = this.props.historyState.error;
    else if (this.props.settingsFetchingError) error = this.props.settingsFetchingError;
    else if (this.props.settingsAddingError) error = this.props.settingsAddingError;
    return !error ? null :
      <p className="text-danger">Error: {error.toString()}</p>;
  };

  onDisplayedColumnsChanged = (isChecked, columnName) => {
    this.setState({
      displayedColumns: isChecked ? [...this.state.displayedColumns, columnName] :
        this.state.displayedColumns.filter(column => column !== columnName)
    }, () => this.props.addUserSettings({ visibleColumns: this.state.displayedColumns }));
  };

  changeFilter = (colName, value, onChanged) => {
    this.props.setFilterValue(colName, value).then(onChanged);
  };

  clearFilters = () => {
    this.props.clearFilters().then(this.reloadHistory);
  };

  createColumnFormatter = (name, filterType, values) => {
    if (ColumnFormatters[filterType === undefined])
      return null;
    return (column, colIndex, { sortElement, filterElement }) => {
      const val = this.props.filters[name];
      let params = {
        value: val,
        onEnter: this.reloadHistory
      };
      let onChanged = filterType === 'select' ? this.reloadHistory : () => { };
      if (values !== undefined)
        params['filterValues'] = values;
      params['onChange'] = value => this.changeFilter(name, value, onChanged);
      return ColumnFormatters[filterType](column, colIndex, { sortElement, filterElement }, params);
    };
  };

  onTableChange = (type, { page, sizePerPage, sortField, sortOrder }) => {
    const { filters, sort } = this.props;
    if (type === 'pagination') {
      this.setState({ pagination: { page, sizePerPage } });
      this.props.setPagination({ page, sizePerPage });
      this.props.fetchNextHistory({
        filters, sort, limit: sizePerPage, offset: (page - 1) * sizePerPage
      });
    } else if (type === 'sort') {
      if ((this.props.sort.dataField === sortField) && (this.props.sort.order === sortOrder)) {
        return;
      }
      this.setState({ sort: { dataField: sortField, order: sortOrder } }, this.reloadHistory);
    }
  };

  renderWrongActivationsTable = () => {
    return (
      <Modal bsSize="lg" backdrop="static"
        show={this.state.isShowWrongActivationsTable}
        onHide={this.hideWrongActivationsTable}
        onShow={this.onWrongActivationsTableShown}
      >
        <Modal.Header>
          <Modal.Title>Wrong activations table</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <OverlayLoader
            active={this.props.historyState.isWrongActivationsHistoryFetching}
            text={'Wrong activations history loading...'}
          >
            <div>
              {this.props.historyState.wrongActivationsHistoryError
                ?
                <p className="text-danger">Error: {this.props.historyState.wrongActivationsHistoryError.toString()}</p>
                : <WrongActivationsHistoryTable history={this.props.historyState.wrongActivationsHistory} />
              }
            </div>
          </OverlayLoader>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={this.hideWrongActivationsTable}>Close</Button>
        </Modal.Footer>
      </Modal>
    );
  }

  showWrongActivationsTable = () => {
    this.setState({ isShowWrongActivationsTable: true });
  }

  hideWrongActivationsTable = () => {
    this.setState({ isShowWrongActivationsTable: false });
  }

  onWrongActivationsTableShown = () => {
    this.props.fetchWrongActivationsHistory({
      sort: this.props.wrongActivationsHistorySort
    });
  }

  getPaginationOptions = () => {
    const { totalCount } = this.props;
    const { page, sizePerPage } = this.state.pagination;

    return {
      page,
      sizePerPage,
      sizePerPageList: ItemsPerPageModes,
      totalSize: totalCount ? totalCount : (page * sizePerPage) + 1,
    };
  }

  renderTable = () => {
    const isAnyFilterApplied = Object.keys(this.props.filters).length !== 0;
    const paginationOptions = this.getPaginationOptions();

    return (
      <div>
        <div className="mt-3">
          {this.columns.map(column => <Checkbox
            inline
            checked={this.state.displayedColumns.includes(column.dataField)}
            onChange={e => this.onDisplayedColumnsChanged(e.target.checked, column.dataField)}
            key={column.dataField}
          >
            {column.text}
          </Checkbox>)}
        </div>
        <FilterTableHeader
          total={this.props.totalCount}
          isTotalFetching={this.props.isTotalFetching}
          isBackgroundRequestsEnabled={this.props.isBackgroundRequestsEnabled}
          setIsBackgroundRequestsEnabled={this.props.setIsBackgroundRequestsEnabled}
          onToggleIsBackgroundRequestsEnabled={this.handleToggleIsBackgroundRequestsEnabled}
          clearFilters={this.clearFilters}
          isAnyFilterApplied={isAnyFilterApplied}
          totalControls
        />
        <BootstrapTable
          remote
          striped
          keyField="id"
          data={this.props.historyState.history}
          columns={this.columns.filter(column => this.state.displayedColumns.includes(column.dataField))}
          pagination={paginationFactory(paginationOptions)}
          classes="autoWithColumnTable"
          onTableChange={this.onTableChange}
          defaultSorted={[this.props.sort]}
          noDataIndication="History is empty"
        />
      </div>
    );
  };

  isLoading = () => this.props.historyState.isFetching ||
    this.props.isSettingsFetching;

  getLoaderMessage = () => {
    if (this.props.historyState.isFetching) return "History loading...";
    if (this.props.isSettingsFetching) return "User settings loading...";
  };

  getLinkToTab = (cell, row) => {
    let tab = "";
    let filter = "license.key";
    switch (row.requestType) {
      case "check":
        if (row.responseType && row.responseType.includes("Permanent"))
          tab = "permanent-licenses";
        else
          tab = "temporary-licenses";
        break;
      case "check_web_viewer_server":
        tab = "web-viewer-servers";
        filter = 'server.key';
        break;
      case "check_web_viewer_license":
        tab = "web-viewer-licenses";
        break;
      default:
        tab = "permanent-licenses";
        break;
    }

    return `/${tab}?${filter}=${cell}`;
  };
}

const mapStateToProps = (state) => ({
  totalCount: historySelectors.historyState(state).totalCount,
  isTotalFetching: historySelectors.historyState(state).isTotalFetching,
  isBackgroundRequestsEnabled: historySelectors.historyState(state).isBackgroundRequestsEnabled,
  historyState: historySelectors.historyState(state),
  filters: userConfigsSelectors.filterValues(state, thatObjectName),
  settings: settingsSelectors.history(state),
  isSettingsFetching: settingsSelectors.isFetching(state),
  settingsFetchingError: settingsSelectors.fetchingError(state),
  settingsAddingError: settingsSelectors.addingError(state),
  sort: userConfigsSelectors.sortTables(state, thatObjectName),
  wrongActivationsHistorySort: userConfigsSelectors.sortTables(state, 'wrongActivationsHistory'),
});

const actionCreators = {
  fetchStartHistory: historyActions.fetchStartHistory,
  fetchNextHistory: historyActions.fetchNextHistory,
  fetchHistoryTotal: historyActions.fetchHistoryTotal,
  setIsBackgroundRequestsEnabled: historyActions.setIsBackgroundRequestsEnabled,
  setPagination: historyActions.setPagination,
  setFilterValue: (filterName, value) => filterValuesActions.setFilterValue(thatObjectName, filterName, value),
  clearFilters: () => filterValuesActions.clearFilters(thatObjectName),
  fetchUserSettings: () => settingsActions.fetchUserSettings({ objectName: thatObjectName }),
  addUserSettings: (settings) => settingsActions.postUserSettings({ objectName: thatObjectName, settings }),
  setOrderDirection: (dataField, order) => sortTablesActions.setSortDirection(thatObjectName, dataField, order),
  fetchWrongActivationsHistory: historyActions.fetchWrongActivationsHistory,
};

export default connect(mapStateToProps, actionCreators)(HistoryContainer);



// WEBPACK FOOTER //
// ./src/containers/historyContainer.js